export default {
  heading: 'Example Heading',
  component: 'a-heading',
}
